import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { tryParseJson } from "@poseidon/utils/obj";
import { useCallback } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { storage } from "@poseidon/firebase";
import { getDoc } from "firebase/firestore";
import { getDownloadURL, ref } from "firebase/storage";

const ResultTable = ({ result }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell component="th">Field</TableCell>
          <TableCell component="th">Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow key="result">
          <TableCell>Result</TableCell>
          <TableCell>{result.attributes?.result}</TableCell>
        </TableRow>
        <TableRow key="riskLevel">
          <TableCell>Risk Level</TableCell>
          <TableCell>{result.attributes?.risk_level}</TableCell>
        </TableRow>
        <TableRow key="pep">
          <TableCell>PEP</TableCell>
          <TableCell>
            {result.attributes?.due_diligence.politically_exposed_person}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export const AmlCheck = ({ amlCheck }) => {
  const viewPdf = useCallback(async () => {
    const fileSnapshot = await getDoc(amlCheck.summaryDocument);
    const uploadPath = fileSnapshot.data().uploadPath;
    const pathReference = ref(storage, uploadPath);
    return getDownloadURL(pathReference)
      .then((url) => {
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.error(error.code);
        return Error(error);
      });
  }, [amlCheck]);

  const viewPortal = useCallback(() => {
    window.open(
      `${process.env.NX_SMARTSEARCH_PORTAL_URL}aml/results/${amlCheck.result.id}`,
      "_blank"
    );
  }, [amlCheck]);

  if (amlCheck.error) {
    return (
      <Alert severity="error">
        <Typography variant="body1">
          {tryParseJson(amlCheck.error) || amlCheck.error || "Unknown error"}
        </Typography>
      </Alert>
    );
  }

  if (!amlCheck.result) {
    return <Alert severity="warning">No result available</Alert>;
  }

  return (
    <Stack spacing={2}>
      <ResultTable result={amlCheck.result} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          sx={{ width: "49%" }}
          variant="outlined"
          size="small"
          onClick={viewPdf}
        >
          View PDF
        </Button>
        <Button
          sx={{ width: "49%" }}
          variant="outlined"
          size="small"
          onClick={viewPortal}
        >
          View Portal
        </Button>
      </Box>
    </Stack>
  );
};
